import { render } from "./RouteAccess.vue?vue&type=template&id=25cab8e2&ts=true&lang=pug"
import script from "./RouteAccess.vue?vue&type=script&lang=ts"
export * from "./RouteAccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__